var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "WhatsApp_x0020_Logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 121.582,
    viewBox: "0 0 121 121.582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2142256039952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_70261",
    "data-name": "Grupo 70261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4446",
    "data-name": "Trazado 4446",
    d: "M103.371,17.668A60.261,60.261,0,0,0,8.547,90.362L0,121.582,31.938,113.2a60.2,60.2,0,0,0,28.791,7.333h.025A60.273,60.273,0,0,0,103.371,17.668ZM60.753,110.362h-.02a50,50,0,0,1-25.486-6.98L33.417,102.3l-18.953,4.971,5.059-18.478L18.333,86.9a50.075,50.075,0,1,1,42.42,23.466Zm27.467-37.5h0c-1.505-.753-8.906-4.394-10.287-4.9s-2.383-.754-3.387.753-3.888,4.9-4.767,5.9-1.756,1.13-3.261.376a41.089,41.089,0,0,1-12.106-7.472,45.379,45.379,0,0,1-8.375-10.428c-.877-1.507-.093-2.321.661-3.072.677-.675,1.505-1.759,2.258-2.638a10.285,10.285,0,0,0,1.505-2.511,2.774,2.774,0,0,0-.125-2.637c-.376-.754-3.387-8.163-4.642-11.178-1.222-2.935-2.463-2.537-3.387-2.584-.877-.043-1.882-.053-2.885-.053A5.531,5.531,0,0,0,35.409,34.3,16.886,16.886,0,0,0,30.14,46.863c0,7.41,5.394,14.568,6.147,15.572S46.9,78.645,62,85.166a86.385,86.385,0,0,0,8.582,3.171,20.619,20.619,0,0,0,9.482.6c2.892-.431,8.907-3.641,10.161-7.158s1.254-6.531.877-7.158S89.725,73.612,88.22,72.858Z",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.7b9f666faba1134a5861df69d925cdd5.svg";
export { ForwardRef as ReactComponent };